/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_OrderInputs */

const en_tables_rule_sets_order = /** @type {(inputs: Tables_Rule_Sets_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Order`)
};

const de_tables_rule_sets_order = /** @type {(inputs: Tables_Rule_Sets_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Sets Order" |
*
* @param {Tables_Rule_Sets_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_order = /** @type {((inputs?: Tables_Rule_Sets_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_order(inputs)
	return de_tables_rule_sets_order(inputs)
});